import { ApiResponse, IDaypart } from 'src/interfaces';

export const mapAllDayparts = (dayparts: ApiResponse[]): IDaypart[] => {
  return dayparts.map((daypart: ApiResponse) => {
    return mapDaypart(daypart);
  });
};

export const mapDaypart = (daypart: ApiResponse): IDaypart => {
  return {
    id: daypart.id,
    name: daypart.name,
    default_start_time: daypart.default_start_time,
    created_at: daypart.created_at,
    modified_at: daypart.modified_at,
  };
};
